module.exports = __webpack_public_path__ + "media/src/assets/images/pharma-biotech-industry-896e80ba6157527d85bf8fa70b7efec2.svg";